var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('weather',{attrs:{"api-key":"0343b4bd38feb09ade2652bb70ca9602","title":"Leuven","latitude":"50.9052669","longitude":"4.7357654","language":"en","units":"si"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }